import*as o from"react";const r=parseFloat(o.version)>=19||"";export{r as inert};
//# sourceMappingURL=inert.js.map
